import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { users } from "../../rbac-consts";
import { default as SuperAdminClientsContainer } from "./superAdmin/ClientsContainer";
import { default as AdminClientsContainer } from "./admin/ClientsContainer";

const ClientsWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={users.SUPER_ADMIN}
        yes={() => (
          <SuperAdminClientsContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={users.ADMIN}
        yes={() => (
          <AdminClientsContainer />
        )}
      />
    </>
  );
};

export default ClientsWrapper;